import httpClient from '@/api/httpClient'

export default class POISearchAPI {
  static async getPoiLocationList(
    categoryId,
    conditions,
    administrativeDistrictType,
    area,
  ) {
    try {
      const res = await httpClient.post('poi/search', {
        categoryId,
        conditions,
        administrativeDistrictType,
        area,
      })
      return res.data
    } catch (error) {
      console.error(error)
    }
  }
}
